/**
 * Single source of truth for the languages the app offers.
 *
 * Adding a language is a two-step change: add an entry here and drop a matching
 * translation file under src/assets/i18n/ (see docs/i18n.md). Both the Transloco
 * provider config and the in-app language selector read from this list, so they
 * can never drift apart.
 */
export interface AppLanguage {
  /** BCP-47 / Transloco lang id, e.g. 'en'. Also the translation filename stem. */
  readonly id: string;
  /** Human-readable label shown in the language selector, in its own language. */
  readonly label: string;
}

export const AVAILABLE_LANGS: readonly AppLanguage[] = [
  { id: 'en', label: 'English' },
] as const;

export const DEFAULT_LANG = 'en';

export function isSupportedLang(lang: string | undefined | null): boolean {
  return !!lang && AVAILABLE_LANGS.some((l) => l.id === lang);
}
